module.exports = __webpack_public_path__ + "img/confirm_offer.3bedcaf8.svg";